/* eslint-disable max-classes-per-file,class-methods-use-this */
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { NAccount } from 'SharedDir/declarations/account';
import { SystemUser, SystemUserIn, SystemUserUpdate, WithEmail } from 'SharedDir/declarations/user';
import { ADMINISTRATION_USER, userUrl } from 'SharedDir/backend/endpoints/administration-user';
import { PaginationParams } from 'SharedDir/declarations/pagination';
import { IntervalStatistics } from 'SharedDir/declarations/statistics';
import fileDownloader from 'SharedDir/utils/file-downloader';

import MyHouseHold = NAccount.MyHouseHold;

export default class UserApiClass extends SimpleApi<
  SystemUser,
  WithEmail<SystemUserIn>,
  SystemUserUpdate
> {
  constructor() {
    super(userUrl);
  }

  // eslint-disable-next-line class-methods-use-this
  async getShortsUserList(params) {
    const { data } = (await http({
      ...ADMINISTRATION_USER.SHORT_LIST,
      params,
    })) as AxiosResponse;
    return data;
  }

  /**
   * Получить обычных пользователей, т.е. пользователей с ролью "пользователь"
   * Данные пользователи получают услуги, меры поддержки и пр + они же имеют профиля
   *
   * @param params
   * @returns
   */
  // eslint-disable-next-line class-methods-use-this
  async recipients<Extra extends object>(params: PaginationParams<Extra>) {
    const { data } = (await http({
      ...ADMINISTRATION_USER.RECIPIENTS,
      params,
    })) as AxiosResponse;
    return data;
  }

  /**
   * Получаем информацию об
   * @param id
   */
  async getTtpInfo(id: number) {
    const { data } = (await http(ADMINISTRATION_USER.TTP_INFO(id))) as AxiosResponse<MyHouseHold>;
    return data;
  }

  async restore(id: number) {
    const { data } = (await http(ADMINISTRATION_USER.RESTORE(id))) as AxiosResponse;
    return data;
  }

  async getIntervalStatistics(
    params: IntervalStatistics.LoginFilters
  ): Promise<IntervalStatistics.LoginResponse> {
    const { data } = await http({
      ...ADMINISTRATION_USER.INTERVAL_STATISTICS,
      params,
    });
    return data;
  }

  async exportIntervalStatistics(params: IntervalStatistics.LoginFilters): Promise<void> {
    fileDownloader.saveFileFromResponse(
      await http({
        ...ADMINISTRATION_USER.INTERVAL_STATISTICS_EXPORT,
        params,
        responseType: 'blob',
      })
    );
  }
}
